export default {
  codeInvalid: false,
  codeValid: false,
};
